import { Flex, Stack, useMediaQuery } from '@chakra-ui/react';

import splitSectionColumns from './helpers/splitSectionColumns';

// (3156) Two columns from 1024px up, one below.
const TWO_COLUMN_QUERY = '(min-width: 1024px)';
const SECTION_GAP = 3;

/**
 * (3156) Lays the service sections out without wasted space: at most two
 * columns that stack independently, and the last of an odd number spanning
 * the full width.
 *
 * @param {object} props
 * @param {import('react').ReactElement[]} props.sections - keyed, in order
 */
const ServiceSectionGrid = ({ sections }) => {
    const [isWide] = useMediaQuery(TWO_COLUMN_QUERY);

    if (!isWide) {
        return <Stack spacing={SECTION_GAP}>{sections}</Stack>;
    }

    const { left, right, fullWidth } = splitSectionColumns(sections);

    return (
        <Stack spacing={SECTION_GAP}>
            {left.length > 0 && (
                <Flex gap={SECTION_GAP} align="flex-start">
                    <Stack flex="1" minW={0} spacing={SECTION_GAP}>
                        {left}
                    </Stack>
                    <Stack flex="1" minW={0} spacing={SECTION_GAP}>
                        {right}
                    </Stack>
                </Flex>
            )}
            {fullWidth}
        </Stack>
    );
};

export default ServiceSectionGrid;
